(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/lobby/play/leia/use-custom-events.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/lobby/play/leia/use-custom-events.js');
"use strict";

const useCustomEvents = _ref => {
  let {
    ticketInfo,
    wager,
    isDemo,
    onClose,
    onPlay,
    dispatch,
    updateCategories
  } = _ref;
  const {
    gameEngineCode
  } = svs.ticketgames.ticketUtility.utils.constants.leia;
  const {
    resultDialogDemo
  } = svs.ticketgames.ticketUtility.utils.resultDialog;
  const {
    useState,
    useRef
  } = React;
  const {
    showReceipt,
    showOngoingDialog
  } = svs.eInstant.lobby.play.utils;
  const lastWonAmountRef = useRef(-1);
  const [isLoading, setIsLoading] = useState(true);
  const [isOngoingGame, setIsOngoingGame] = useState(Boolean(wager));
  const [showPlayAgain, setShowPlayAgain] = useState(false);
  const shouldShowPlayAgain = ticketInfo.open && (wager === null || wager === void 0 ? void 0 : wager.completed) && showPlayAgain;
  const getLastWonAmount = () => lastWonAmountRef.current;
  const handleGameLoaded = () => {
    setIsLoading(false);
    svs.eInstant.lobby.play.utils.hideHeaders(true);
    if (wager !== null && wager !== void 0 && wager.completed) {
      showReceipt();
      setShowPlayAgain(true);
    }
  };
  const handleOngoingGame = data => {
    if (data.detail) {
      var _requestResponse$data;
      const {
        event,
        requestResponse = {},
        eventType
      } = data.detail;
      if ((event === 'getItgTickets' || event === 'getEinTickets') && eventType === 'requestResponse' && requestResponse.data.length >= 1) {
        if (!wager) {
          dispatch({
            type: 'SET_BET_ID',
            payload: requestResponse.data[0].id
          });
          showOngoingDialog();
          setIsOngoingGame(false);
        }
      }
      if (isOngoingGame && event === 'updateItgBet' && eventType === 'requestResponse' && (_requestResponse$data = requestResponse.data) !== null && _requestResponse$data !== void 0 && _requestResponse$data.data && !wager) {
        var _requestResponse$data2;
        dispatch({
          type: 'SET_BET_ID',
          payload: (_requestResponse$data2 = requestResponse.data.data) === null || _requestResponse$data2 === void 0 ? void 0 : _requestResponse$data2.id
        });
        setIsOngoingGame(false);
        showOngoingDialog();
      }
    }
  };
  const handleHasClaimed = data => {
    if (data !== null && data !== void 0 && data.detail) {
      const {
        detail
      } = data;
      let playAgain;
      switch (ticketInfo.gameEngineCode) {
        case gameEngineCode.VEIKKAUS:
          playAgain = () => {
            var _gameloaderHelper$ins;
            (_gameloaderHelper$ins = gameloaderHelper.instance) === null || _gameloaderHelper$ins === void 0 || (_gameloaderHelper$ins = _gameloaderHelper$ins.bridgeWindow) === null || _gameloaderHelper$ins === void 0 || _gameloaderHelper$ins.postMessage({
              type: 'confirm',
              data: {
                context: 'rebuy',
                option: 'cancel' 
              }
            }, svs.ticketUtility.data.gameloaderHelperConfig.itf.url);
          };
          break;
        default:
          break;
      }
      if (isDemo) {
        var _detail$wonAmount;
        lastWonAmountRef.current = (detail === null || detail === void 0 || (_detail$wonAmount = detail.wonAmount) === null || _detail$wonAmount === void 0 ? void 0 : _detail$wonAmount.value) / 100;
        resultDialogDemo({
          wonAmount: detail === null || detail === void 0 ? void 0 : detail.wonAmount,
          onClose: () => {
            onClose(ticketInfo, {
              isDemo: true,
              winAmount: lastWonAmountRef.current
            });
          },
          onPlayAgain: () => onPlay(ticketInfo)
        });
      } else {
        svs.components.account_balance.get(true);
        if (!wager || !wager.completed) {
          var _detail$wonAmount2;
          updateCategories();
          lastWonAmountRef.current = (detail === null || detail === void 0 || (_detail$wonAmount2 = detail.wonAmount) === null || _detail$wonAmount2 === void 0 ? void 0 : _detail$wonAmount2.value) / 100;
        }
        svs.ticketgames.ticketUtility.utils.resultDialog.resultDialogNormal({
          wonAmount: detail === null || detail === void 0 ? void 0 : detail.wonAmount,
          onClose: () => {
            onClose(ticketInfo, {
              isCompleted: wager === null || wager === void 0 ? void 0 : wager.completed,
              winAmount: lastWonAmountRef.current
            });
          },
          onPlayAgain: wager ? () => onPlay(ticketInfo) : playAgain,
          isTicketOpen: ticketInfo.open
        });
      }
    }
  };
  const handleHasBet = _ref2 => {
    let {
      detail
    } = _ref2;
    if (!isDemo) {
      const {
        data,
        betAmount,
        serviceName
      } = detail;
      dispatch({
        type: 'SET_BET_ID',
        payload: data.id
      });
      const ticketPrice = betAmount.value / 100;
      svs.ticketgames.ticketUtility.utils.tracking.sendAnalytics(data.id, serviceName, ticketPrice, ticketInfo, false);
    }
  };
  return {
    isLoading,
    shouldShowPlayAgain,
    getLastWonAmount,
    handleGameLoaded,
    handleOngoingGame,
    handleHasClaimed,
    handleHasBet
  };
};
setGlobal('svs.eInstant.lobby.play.leia.useCustomEvents', useCustomEvents);

 })(window);